import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { WIDGET_WITH_CART_DATA } from "../../../../Data/Widgets/GeneralWidgets";
import { H4 } from "../../../../AbstractElements";

const WidgetsWithChart = () => {
  return (
    <>
      {WIDGET_WITH_CART_DATA.map((data, index) => (
        <Col sm="6" key={index}>
          <Card className="widget-1 widget-with-chart mb-xl-0">
            <CardBody>
              <div>
                <H4 className="mb-1">{data.amount}</H4>
                <span className="f-light">{data.tittle}</span>
              </div>
              <div className="order-chart">
                <ReactApexChart
                  height={150}
                  type={data.tittle === "Profit" ? "line" : "bar"}
                  options={data.chartOption}
                  series={data.chartOption.series}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default WidgetsWithChart;
